import { Client } from "./Client";

export class ForecastService {
  constructor(private client: Client) {}

  async fetchForecast(facilityID: string, period: string) {
    return await this.client.fetchFacilityForecast(facilityID, period);
  }
}
